<template>
  <div
    class="precipitation-calculator"
  >
    <h4>Precipitation Calculator</h4>
    <div
      class="edit-grid"
    >
      <div class="grid__title">
        <h5>Flow Rate</h5>
      </div>
      <div>
        <input
          v-model="flowRate"
          type="text"
          pattern= "^\d*\.?\d+$"
        >
        {{ getDenominator('litre', 'gallon', 0) + '/' + $tc('messages.sharedTexts.time.m', 1) }}
      </div>

      <div class="grid__title">
        <h5>Head Spacing</h5>
      </div>
      <div>
        <input
          v-model="headSpacing"
          type="text"
          pattern= "^\d*\.?\d+$"
        >
        {{ getDenominator('centimetre', 'foot', 0) }}
      </div>

      <div class="grid__title">
        <h5>Row Spacing</h5>
      </div>
      <div>
        <input
          v-model="rowSpacing"
          type="text"
          pattern= "^\d*\.?\d+$"
        >
        {{ getDenominator('centimetre', 'foot', 0) }}
      </div>

      <div class="grid__title">
        <h5>Arc</h5>
      </div>
      <div>
        <input
          v-model="arc"
          type="text"
          pattern= "^\d*\.?\d+$"
        >
        degrees
      </div>

      <div class="grid__title">
        <h5>Precipitation rate</h5>
      </div>
      <div>
        <input
          :value="computedPrecipitationRate.toFixed(2)"
          disabled
          type="text"
          min="0"
        >
        {{ getDenominator('centimetre', 'inch', 0) + '/' + $tc('messages.sharedTexts.time.h', 1) }}
      </div>
    </div>
    <div class="copy">
      <button
        class="g-btn g-btn--blue g-btn--rounded"
        :disabled="computedPrecipitationRate === 0"
        @click.stop="transferValue"
      >
        Transfer Value
      </button>
    </div>
  </div>
</template>

<script>
import {SocketHandler, LifeCycle, UnitSystem} from '@/assets/javascript/mixins/Mixins'

export default {
  name: 'PrecipitationCalculatorElement',
  mixins: [UnitSystem],
  props:
  {
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    ModalData: {
      type: Object,
      default: function() {
        return{}
      }
    },
    store: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return {
      flowRate: 0,
      headSpacing: 0,
      rowSpacing: 0,
      arc: 0
    }
  },
  computed: {
    computedPrecipitationRate() {
      const waterPerMinute = parseFloat(this.flowRate, 10)
      const shs = parseFloat(this.headSpacing, 10)
      const srs = parseFloat(this.rowSpacing, 10)
      const sa = parseFloat(this.arc, 10)

      return waterPerMinute && shs && srs && sa
      ? (96.25 * (waterPerMinute * 360 / sa) / (shs * srs))
      : 0
    }
  },
  methods: {
    transferValue() {
      this.$emit('transfer-precip', this.convertUnits(this.computedPrecipitationRate, 'cm', 'in'))
    }
  }
}
</script>

<style lang="scss">
  .precipitation-calculator {
    h4 {
      margin-top: 10px;
    }

    .copy {
      text-align: right;
      margin-right: 20px;

      button[disabled] {
        background-color: $color-grey;
      }
    }
  }
</style>
